import React from 'react';
import cn from 'classnames';
import {StandardProps} from '..';

type IconButtonSize = 'extraSmall' | 'small' | 'medium' | 'large';
type IconButtonEdge = 'end' | 'start';

function getIconButtonSizeClassName(size?: IconButtonSize) {
  switch (size) {
    case 'extraSmall':
      return 'icon-button--extraSmall';
    case 'small':
      return 'icon-button--small';
    case 'medium':
      return 'icon-button--medium';
    case 'large':
      return 'icon-button--large';
    default:
      return '';
  }
}

function getIconButtonEdgeClassName(edge?: IconButtonEdge) {
  switch (edge) {
    case 'end':
      return 'icon-button--edge-end';
    case 'start':
      return 'icon-button--edge-start';
    default:
      return '';
  }
}


export interface IconButtonProps extends StandardProps<React.ButtonHTMLAttributes<HTMLButtonElement>> {
  size?: IconButtonSize;
  ref?: React.ForwardedRef<HTMLButtonElement>;
  edge?: IconButtonEdge;
}

export const IconButton = React.forwardRef<HTMLButtonElement, IconButtonProps>(
  ({className, size = 'medium', edge, type = 'button', ...restProps}, ref) => {
    return (
      <button
        ref={ref}
        type={type}
        className={cn(
          'icon-button',
          getIconButtonSizeClassName(size),
          getIconButtonEdgeClassName(edge),
          className,
        )}
        {...restProps}
      />
    );
  },
);

export default IconButton;
